import { FAQsPage } from './faqs-page.component';

export default FAQsPage;
